import { render } from "./AutoRefresh.vue?vue&type=template&id=120752a4&scoped=true"
import script from "./AutoRefresh.vue?vue&type=script&lang=js"
export * from "./AutoRefresh.vue?vue&type=script&lang=js"

import "./AutoRefresh.vue?vue&type=style&index=0&id=120752a4&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120752a4"]])

export default __exports__